export default __webpack_public_path__ + "static/media/license_code.daa83c8b.png";